import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AviationEvent, AviationEventType, AviationEventTypeDesc, TimeZones } from '../../shared/models/aviation-event.model';
import { MatDatepickerInputEvent, MatDialogRef, MatSelectChange, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { AirportService } from '../../airport/airport.service';
import { LatLon } from '../../util/geodesy/latlon';
import { GoogleService } from '../../google/google.service';
import { GoogleMapsValidationModel } from '../../google/google-maps-validation.model';
import { AddressValidationService } from '../../google/address-validation.service';
import { eventUSStates, eventCanadianProvinces, eventCountries, eventAMPM, eventHours, eventMinutes } from '../../globals';
var Granularity = GoogleMapsValidationModel.Granularity;
import * as MomentTZ from 'moment-timezone';
var USTimezones = [
    { id: 1, countryCode: 'America/Halifax', zoneName: 'ATLANTIC' },
    { id: 2, countryCode: 'America/New_York', zoneName: 'EASTERN' },
    { id: 3, countryCode: 'America/Chicago', zoneName: 'CENTRAL' },
    { id: 4, countryCode: 'America/Denver', zoneName: 'MOUNTAIN' },
    { id: 5, countryCode: 'America/Los_Angeles', zoneName: 'PACIFIC' },
    { id: 6, countryCode: 'Pacific/Honolulu', zoneName: 'HAWAII' },
    { id: 7, countryCode: 'America/Anchorage', zoneName: 'ALASKA' }
];
var EditEventLocationComponent = /** @class */ (function () {
    function EditEventLocationComponent(_matDialogRef, data, _aviationEventsService, _fb, _snackBar, _airportService, _googleService, _addressValidationService) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this._fb = _fb;
        this._snackBar = _snackBar;
        this._airportService = _airportService;
        this._googleService = _googleService;
        this._addressValidationService = _addressValidationService;
        this.isLoading = true;
        this.eventCountries = eventCountries;
        this.airports = [];
        this.selectedAirport = null;
        this.airportSelectionError = false;
        this.showAddressFields = true;
        this.initialAirport = '';
        this.initialAirportId = 0;
        this.startDateMin = new Date();
        this.endDateMin = this.startDateMin;
        this.timeZones = Object.keys(TimeZones).sort();
        // tslint:disable-next-line:max-line-length
        this.urlRegex = /^((https?|http):\/\/)?(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
        this.eventHours = eventHours;
        this.eventMinutes = eventMinutes;
        this.eventAMPM = eventAMPM;
        this.aviationEvent = data.aviationEvent;
        this.currentCountry = this.aviationEvent.country;
        this.initialCountryCode = this.aviationEvent.countryCode;
    }
    EditEventLocationComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, currentEventType;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._matDialogRef.backdropClick().subscribe(function () {
                            _this._matDialogRef.close(null);
                        });
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getCountries()];
                    case 1:
                        _a.countries = _b.sent();
                        if (!(this.aviationEvent.airportIdent && this.aviationEvent.airportIdent.length > 0)) return [3 /*break*/, 3];
                        this.initialAirportId = this.aviationEvent.airportId;
                        return [4 /*yield*/, this._airportService.getAirport(this.aviationEvent.airportIdent, false).then(function (res) {
                                _this.initialAirport = res.identifier + ': ' + res.name;
                            }).catch(function (err) { return console.error(err); })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        /* let currentTimeZoneSimpleName = 'America/New_York';
                        if (this.initialCountryCode === 'US') {
                          console.log('this.aviationEvent.timezone: ', this.aviationEvent.timezone);
                          currentTimeZoneSimpleName = USTimezones.find(i => i.countryCode === this.aviationEvent.countryCode).zoneName;
                        } else {
                          currentTimeZoneSimpleName = this.aviationEvent.timezone;
                        } */
                        // const currentTimeZoneSimpleName =  Object.keys(TimeZones).filter(it => TimeZones[it] === this.aviationEvent.timezone).pop();
                        this.eventTypes = Object.values(AviationEventTypeDesc);
                        currentEventType = AviationEventTypeDesc[AviationEventType[this.aviationEvent.typeId]];
                        this.eventStart = MomentTZ.tz(this.aviationEvent.startDateTime, 'UTC');
                        this.eventStartDateString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
                        this.eventStartTimeString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('HH:mm');
                        this.eventEnd = MomentTZ.tz(this.aviationEvent.endDateTime, 'UTC');
                        this.eventEndDateString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
                        this.eventEndTimeString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('HH:mm');
                        this.startDate = this.eventStart.clone().tz(this.aviationEvent.timezone).toDate();
                        this.endDate = this.eventEnd.clone().tz(this.aviationEvent.timezone).toDate();
                        this.startHour = this.eventStart.clone().tz(this.aviationEvent.timezone).format('h');
                        this.startMin = this.eventStart.clone().tz(this.aviationEvent.timezone).format('mm');
                        this.startAMPM = this.eventStart.clone().tz(this.aviationEvent.timezone).format('A');
                        this.endHour = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('h');
                        this.endMin = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('mm');
                        this.endAMPM = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('A');
                        this.formGroup = this._fb.group({
                            format: [this.aviationEvent.format, [Validators.maxLength(32)]],
                            venueLocationName: [this.aviationEvent.venueLocationName, Validators.required],
                            address1: [this.aviationEvent.address1, Validators.required],
                            address2: [this.aviationEvent.address2, Validators.nullValidator],
                            address3: [this.aviationEvent.address3, Validators.nullValidator],
                            city: [this.aviationEvent.city, Validators.required],
                            isOnAirport: [!!this.aviationEvent.airportId, Validators.nullValidator],
                            airport: [this.initialAirport, Validators.nullValidator],
                            stateProvince: [this.aviationEvent.stateProvince, Validators.required],
                            zipcode: [this.aviationEvent.zipcode, Validators.required],
                            country: [this.initialCountryCode, Validators.required],
                            internationalAirportId: [this.aviationEvent.internationalAirportId, Validators.nullValidator],
                            internationalAirportName: [this.aviationEvent.internationalAirportName, Validators.nullValidator],
                            latitude: [this.aviationEvent.latitude, [Validators.min(-90), Validators.max(90), Validators.pattern('^-?\\d+[.]\\d+$')]],
                            longitude: [this.aviationEvent.longitude, [Validators.min(-180), Validators.max(180), Validators.pattern('^-?\\d+[.]\\d+$')]],
                            startDate: [this.startDate, Validators.required],
                            endDate: [this.endDate, Validators.required],
                            startHour: [this.startHour, Validators.required],
                            startMin: [this.startMin, Validators.required],
                            startAMPM: [this.startAMPM, Validators.required],
                            endHour: [this.endHour, Validators.required],
                            endMin: [this.endMin, Validators.required],
                            endAMPM: [this.endAMPM, Validators.required],
                            timezone: ['' || '', Validators.required],
                            webinarRegistrationLink: [this.aviationEvent.webinarRegistrationLink,
                                [Validators.maxLength(256), Validators.pattern(this.urlRegex)]],
                            informationWebsite: [this.aviationEvent.informationWebsite,
                                [Validators.maxLength(256), Validators.pattern(this.urlRegex)]],
                            websiteCustomLabel: [this.aviationEvent.websiteCustomLabel, [Validators.maxLength(50)]],
                            type: [currentEventType, [Validators.maxLength(256)]],
                            cost: [this.aviationEvent.cost || 'Unknown', [Validators.maxLength(256)]]
                        }, { updateOn: 'submit' });
                        if (this.aviationEvent.format === 'Online') {
                            this._setAddressValidation(false);
                        }
                        else {
                            this._setAddressValidation(true);
                        }
                        return [4 /*yield*/, this.updateTimeZones(this.initialCountryCode)];
                    case 4:
                        _b.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditEventLocationComponent.prototype.getStates = function () {
        var COUNTRY = this.formGroup.value.country;
        var resultArry = [];
        if (COUNTRY === 'US') {
            resultArry = eventUSStates;
        }
        else if (COUNTRY === 'CA') {
            resultArry = eventCanadianProvinces;
        }
        return resultArry;
    };
    EditEventLocationComponent.prototype.showDateError = function () {
        var startDate = this.formGroup.value.startDate;
        startDate.setHours(0, 0, 0, 0);
        var endDate = this.formGroup.value.endDate;
        endDate.setHours(0, 0, 0, 0);
        var startHour = +this.formGroup.value.startHour;
        if (startHour === 12) {
            startHour = 0;
        }
        startHour = this.formGroup.value.startAMPM === 'PM' ? startHour + 12 : startHour;
        var endHour = +this.formGroup.value.endHour;
        if (endHour === 12) {
            endHour = 0;
        }
        endHour = this.formGroup.value.endAMPM === 'PM' ? endHour + 12 : endHour;
        var dateBoolean = startDate && endDate && startDate.getTime() > endDate.getTime();
        if (startDate && endDate && startDate.getTime() === endDate.getTime()) {
            return startHour > endHour || (startHour === endHour && +this.formGroup.value.startMin > +this.formGroup.value.endMin);
        }
        return dateBoolean;
    };
    EditEventLocationComponent.prototype.eventDateChange = function (type, event) {
        var element = event.targetElement;
        if (element.getAttribute('name') === 'startDate') {
            this.endDateMin = event.value;
        }
    };
    EditEventLocationComponent.prototype.buildZonedTime = function (date, time, timezone) {
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day = ('0' + date.getDate()).slice(-2);
        var year = date.getFullYear();
        var localTime = MomentTZ.tz(year + "-" + month + "-" + day + " " + time, timezone);
        return localTime.utc().format('MM/DD/YYYY h:mm:ss A');
    };
    EditEventLocationComponent.prototype.statesFieldChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.formGroup.patchValue({ stateProvince: '' });
                        this.formGroup.patchValue({ city: '' });
                        this.formGroup.patchValue({ zipcode: '' });
                        this.formGroup.patchValue({ address1: '' });
                        this.formGroup.patchValue({ address2: '' });
                        this.formGroup.patchValue({ address3: '' });
                        this.formGroup.patchValue({ internationalAirportId: '' });
                        this.formGroup.patchValue({ internationalAirportName: '' });
                        this.formGroup.patchValue({ airport: '' });
                        this.formGroup.patchValue({ latitude: '' });
                        this.formGroup.patchValue({ longitude: '' });
                        this.selectedAirport = null;
                        if (['US', 'CA'].includes(this.formGroup.value.country)) {
                            this.formGroup.controls['city'].setValidators(Validators.required);
                            this.formGroup.controls['stateProvince'].setValidators(Validators.required);
                            this.formGroup.controls['zipcode'].setValidators(Validators.required);
                            this.formGroup.controls['latitude'].setValidators([]);
                            this.formGroup.controls['longitude'].setValidators([]);
                        }
                        else {
                            this.formGroup.controls['city'].setValidators([]);
                            this.formGroup.controls['stateProvince'].setValidators([]);
                            this.formGroup.controls['zipcode'].setValidators([]);
                            this.formGroup.controls['latitude'].setValidators([Validators.required, Validators.min(-90), Validators.max(90),
                                Validators.pattern('^-?\\d+[.]\\d+$')]);
                            this.formGroup.controls['longitude'].setValidators([Validators.required, Validators.min(-180), Validators.max(180),
                                Validators.pattern('^-?\\d+[.]\\d+$')]);
                        }
                        this.formGroup.controls['city'].updateValueAndValidity();
                        this.formGroup.controls['stateProvince'].updateValueAndValidity();
                        this.formGroup.controls['zipcode'].updateValueAndValidity();
                        this.formGroup.controls['latitude'].updateValueAndValidity();
                        this.formGroup.controls['longitude'].updateValueAndValidity();
                        this.currentCountry = event.source.triggerValue;
                        return [4 /*yield*/, this.updateTimeZones(event.value, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditEventLocationComponent.prototype.airportChange = function (airport) {
        this.selectedAirport = airport;
        this.initialAirport = '';
        this.airportSelectionError = false;
    };
    EditEventLocationComponent.prototype.airportSearchFocusOut = function (event) {
        if (this.selectedAirport) {
            this.formGroup.patchValue({ airport: this.selectedAirport.identifier + ": " + this.selectedAirport.name });
        }
        else {
            this.formGroup.patchValue({ airport: '' });
        }
    };
    EditEventLocationComponent.prototype.airportQueryKeyUp = function (event) {
        var _this = this;
        var val = event.target.value;
        if (val.length < 3) {
            if (!val || val.length === 0) {
                this.airportSelectionError = false;
                this.selectedAirport = null;
                this.airports = [];
            }
            return;
        }
        this._airportService.getAirportsBySearchTerm(val, true).then(function (res) {
            _this.airports = res;
        }).catch(function (err) { return console.error(err); });
    };
    EditEventLocationComponent.prototype.eventFormatSelectionChange = function (event) {
        var format = event.value;
        if (format === 'Online') {
            this._setAddressValidation(false);
            this.showAddressFields = false;
            this.formGroup.patchValue({ address1: '' });
            this.formGroup.patchValue({ address2: '' });
            this.formGroup.patchValue({ address3: '' });
            this.formGroup.patchValue({ city: '' });
            this.formGroup.patchValue({ state: '' });
            this.formGroup.patchValue({ zipcode: '' });
            this.formGroup.patchValue({ airport: '' });
            this.formGroup.patchValue({ internationalAirportId: '' });
            this.formGroup.patchValue({ internationalAirportName: '' });
            this.formGroup.patchValue({ latitude: '' });
            this.formGroup.patchValue({ longitude: '' });
        }
        else {
            this._setAddressValidation();
            // this.formGroup.patchValue({country: 'United States'});
            this.showAddressFields = true;
        }
    };
    EditEventLocationComponent.prototype._setAddressValidation = function (validationIsRequired) {
        if (validationIsRequired === void 0) { validationIsRequired = true; }
        this.formGroup.removeControl('address1');
        this.formGroup.removeControl('stateProvince');
        this.formGroup.removeControl('city');
        this.formGroup.removeControl('zipcode');
        // this.formGroup.removeControl('country');
        this.formGroup.removeControl('venueLocationName');
        if (validationIsRequired) {
            this.formGroup.addControl('address1', new FormControl(this.aviationEvent.address1, Validators.required));
            if (['US', 'CA'].includes(this.formGroup.value.country)) {
                this.formGroup.addControl('stateProvince', new FormControl(this.aviationEvent.stateProvince, Validators.required));
                this.formGroup.addControl('city', new FormControl(this.aviationEvent.city, Validators.required));
                this.formGroup.addControl('zipcode', new FormControl(this.aviationEvent.zipcode, Validators.required));
                this.formGroup.addControl('latitude', new FormControl('', Validators.nullValidator));
                this.formGroup.addControl('longitude', new FormControl('', Validators.nullValidator));
            }
            else {
                this.formGroup.addControl('stateProvince', new FormControl('', Validators.nullValidator));
                this.formGroup.addControl('city', new FormControl('', Validators.nullValidator));
                this.formGroup.addControl('zipcode', new FormControl('', Validators.nullValidator));
                this.formGroup.addControl('latitude', new FormControl('', [Validators.required,
                    Validators.min(-90), Validators.max(90), Validators.pattern('^-?\\d+[.]\\d+$')]));
                this.formGroup.addControl('longitude', new FormControl('', [Validators.required,
                    Validators.min(-180), Validators.max(180), Validators.pattern('^-?\\d+[.]\\d+$')]));
            }
            // this.formGroup.addControl('country', new FormControl(this.aviationEvent.country, Validators.required));
            this.formGroup.addControl('venueLocationName', new FormControl(this.aviationEvent.venueLocationName, Validators.required));
        }
        else {
            this.formGroup.addControl('address1', new FormControl('', Validators.nullValidator));
            this.formGroup.addControl('stateProvince', new FormControl('', Validators.nullValidator));
            this.formGroup.addControl('city', new FormControl('', Validators.nullValidator));
            this.formGroup.addControl('zipcode', new FormControl('', Validators.nullValidator));
            // this.formGroup.addControl('country', new FormControl('', Validators.nullValidator));
            this.formGroup.addControl('venueLocationName', new FormControl('', Validators.nullValidator));
        }
    };
    EditEventLocationComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this._matDialogRef.close(result);
        }
    };
    EditEventLocationComponent.prototype.cancel = function () {
        this._matDialogRef.close(null);
    };
    EditEventLocationComponent.prototype.isUSorCA = function () {
        if (this.formGroup.value.country && ['US', 'CA'].includes(this.formGroup.value.country)) {
            return true;
        }
        return false;
    };
    EditEventLocationComponent.prototype.getRegionCodeFromCountry = function (country) {
        switch (country.toLowerCase()) {
            case 'us':
                return 'US';
            case 'ca':
                return 'CA';
            default:
                return null;
        }
    };
    EditEventLocationComponent.prototype._getAviationEventFromFormValue = function (formValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var postalAddress, regionCode, validationResponse, result, verdict, granularityIsCorrect, address, location_1, errorMsg;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postalAddress = null;
                        regionCode = this.getRegionCodeFromCountry(formValue.country);
                        this.aviationEvent.address1 = formValue.address1;
                        this.aviationEvent.address2 = formValue.address2 && formValue.address2.trim();
                        this.aviationEvent.address3 = formValue.address3 && formValue.address3.trim();
                        this.aviationEvent.city = formValue.city;
                        this.aviationEvent.stateProvince = formValue.stateProvince;
                        this.aviationEvent.zipcode = formValue.zipcode;
                        this.aviationEvent.country = this.currentCountry;
                        this.aviationEvent.countryCode = formValue.country;
                        this.aviationEvent.internationalAirportId = formValue.internationalAirportId;
                        this.aviationEvent.internationalAirportName = formValue.internationalAirportName;
                        if (!(regionCode && formValue.address1 && formValue.city && formValue.stateProvince && formValue.zipcode && formValue.country)) return [3 /*break*/, 2];
                        postalAddress = {
                            regionCode: regionCode,
                            languageCode: 'EN',
                            postalCode: this.aviationEvent.zipcode,
                            locality: this.aviationEvent.city,
                            addressLines: [this.aviationEvent.address1],
                        };
                        return [4 /*yield*/, this._addressValidationService
                                .checkAddress(new GoogleMapsValidationModel.RequestBody(postalAddress))];
                    case 1:
                        validationResponse = _a.sent();
                        result = validationResponse.result;
                        verdict = result.verdict;
                        granularityIsCorrect = verdict.geocodeGranularity === Granularity.PREMISE ||
                            verdict.geocodeGranularity === Granularity.SUB_PREMISE;
                        if (!verdict) {
                            this._snackBar.open('Address could not be validated, please try again', null, { duration: 5000 });
                            throw new Error('Address validation failed');
                        }
                        if (granularityIsCorrect && !verdict.hasUnconfirmedComponents) {
                            address = result.address.postalAddress;
                            this.aviationEvent.city = address.locality;
                            this.aviationEvent.zipcode = address.postalCode.split('-')[0];
                            this.aviationEvent.address1 = address.addressLines[0];
                            this.aviationEvent.stateProvince = address.administrativeArea;
                            location_1 = result.geocode && result.geocode.location ?
                                result.geocode.location : null;
                            this.aviationEvent.location = new LatLon(location_1.latitude, location_1.longitude);
                            this.aviationEvent.latitude = location_1.latitude;
                            this.aviationEvent.longitude = location_1.longitude;
                        }
                        else {
                            errorMsg = 'Invalid Address Enter a Correct Address';
                            if (verdict.hasUnconfirmedComponents && result.address.missingComponentTypes) {
                                this._snackBar
                                    .open(errorMsg + ", check: " + result.address.missingComponentTypes.join(', '), null, { duration: 5000 });
                            }
                            else {
                                this._snackBar.open(errorMsg, null, { duration: 5000 });
                            }
                            throw new Error('Invalid Address');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        // International address
                        this.aviationEvent.address1 = formValue.address1;
                        this.aviationEvent.address2 = formValue.address2;
                        this.aviationEvent.address3 = formValue.address3;
                        this.aviationEvent.location = new LatLon(formValue.latitude, formValue.longitude);
                        this.aviationEvent.latitude = formValue.latitude;
                        this.aviationEvent.longitude = formValue.longitude;
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.aviationEvent];
                }
            });
        });
    };
    EditEventLocationComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TEMP_aviationEvent, tzName, startDate, startTime, endDate, endTime, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        TEMP_aviationEvent = this.aviationEvent;
                        tzName = this.formGroup.value.timezone;
                        if (this.formGroup.value.country === 'US') {
                            tzName = USTimezones.find(function (i) { return i.zoneName === _this.formGroup.value.timezone; }).countryCode;
                        }
                        startDate = new Date(this.formGroup.value.startDate);
                        startTime = +this.formGroup.value.startHour < 10 ? '0' + this.formGroup.value.startHour : this.formGroup.value.startHour;
                        // if startTime is 12:00 AM, set to 00:00
                        if (+this.formGroup.value.startHour === 12 && this.formGroup.value.startAMPM === 'AM') {
                            startTime = '00';
                        }
                        else {
                            startTime = this.formGroup.value.startAMPM === 'PM' && +this.formGroup.value.startHour < 12 ? (+startTime + 12).toString() :
                                startTime;
                        }
                        startTime = startTime + ':' + this.formGroup.value.startMin;
                        endDate = new Date(this.formGroup.value.endDate);
                        endTime = +this.formGroup.value.endHour < 10 ? '0' + this.formGroup.value.endHour : this.formGroup.value.endHour;
                        // if endTime is 12:00 AM, set to 00:00
                        if (+this.formGroup.value.endHour === 12 && this.formGroup.value.endAMPM === 'AM') {
                            endTime = '00';
                        }
                        else {
                            endTime = this.formGroup.value.endAMPM === 'PM' && +this.formGroup.value.endHour < 12 ? (+endTime + 12).toString() : endTime;
                        }
                        endTime = endTime + ':' + this.formGroup.value.endMin;
                        this.aviationEvent.format = this.formGroup.value.format;
                        if (this.formGroup.value.airport.trim() && this.selectedAirport == null && this.initialAirportId === 0) {
                            this.airportSelectionError = true;
                            this._snackBar.open('Invalid Airport Selected', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        else if (this.formGroup.invalid) {
                            this._snackBar.open('Form field validation failed. check form values', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        else if (this.showDateError()) {
                            this._snackBar.open('Start time cannot be after end time, check end time is not before start time', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        if (this.formGroup.value.venueLocationName && this.formGroup.value.venueLocationName.trim().length) {
                            this.aviationEvent.venueLocationName = this.formGroup.value.venueLocationName.trim();
                        }
                        else {
                            this.aviationEvent.venueLocationName = null;
                        }
                        this.aviationEvent.address1 = this.formGroup.value.address1;
                        this.aviationEvent.address2 = this.formGroup.value.address2;
                        this.aviationEvent.city = this.formGroup.value.city;
                        this.aviationEvent.stateProvince = this.formGroup.value.stateProvince;
                        this.aviationEvent.zipcode = this.formGroup.value.zipcode;
                        this.aviationEvent.country = this.formGroup.value.country;
                        if (this.formGroup.value.airport.trim().length === 0) {
                            this.aviationEvent.airportId = null;
                        }
                        else if (!this.selectedAirport && this.initialAirportId !== 0) {
                            this.aviationEvent.airportId = this.initialAirportId;
                        }
                        else {
                            this.aviationEvent.airportId = this.selectedAirport ? this.selectedAirport.airportId : null;
                        }
                        if (this.formGroup.value.webinarRegistrationLink && this.formGroup.value.webinarRegistrationLink.trim().length) {
                            this.aviationEvent.webinarRegistrationLink = this.formGroup.value.webinarRegistrationLink.trim();
                        }
                        else {
                            this.aviationEvent.webinarRegistrationLink = null;
                        }
                        if (this.formGroup.value.informationWebsite && this.formGroup.value.informationWebsite.trim().length) {
                            this.aviationEvent.informationWebsite = this.formGroup.value.informationWebsite.trim();
                        }
                        else {
                            this.aviationEvent.informationWebsite = null;
                        }
                        if (this.formGroup.value.websiteCustomLabel && this.formGroup.value.websiteCustomLabel.trim().length) {
                            this.aviationEvent.websiteCustomLabel = this.formGroup.value.websiteCustomLabel.trim();
                        }
                        else {
                            this.aviationEvent.websiteCustomLabel = null;
                        }
                        if (this.formGroup.value.cost && this.formGroup.value.cost.trim().length && this.formGroup.value.cost.trim() !== 'Unknown') {
                            this.aviationEvent.cost = this.formGroup.value.cost.trim();
                        }
                        else {
                            this.aviationEvent.cost = null;
                        }
                        // this.aviationEvent.format = this.formGroup.value.format;
                        this.aviationEvent.type = AviationEvent.parseEventFromString(this.formGroup.value.type);
                        this.aviationEvent.typeId = this.aviationEvent.type;
                        this.aviationEvent.timezone = tzName;
                        this.aviationEvent.startDateTimeUTC = this.buildZonedTime(startDate, startTime, tzName);
                        this.aviationEvent.endDateTimeUTC = this.buildZonedTime(endDate, endTime, tzName);
                        if (!true) return [3 /*break*/, 1];
                        this._getAviationEventFromFormValue(this.formGroup.value)
                            .then(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var e_2;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this._aviationEventsService.updateAviationEvent(this.aviationEvent)];
                                    case 1:
                                        _a.sent();
                                        this.close({ cancelBtnClicked: false, success: true });
                                        return [3 /*break*/, 3];
                                    case 2:
                                        e_2 = _a.sent();
                                        this.aviationEvent = TEMP_aviationEvent;
                                        this.close({ cancelBtnClicked: false, success: false });
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (err) { return console.error(err); });
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._aviationEventsService.updateAviationEvent(this.aviationEvent)];
                    case 2:
                        _a.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.aviationEvent = TEMP_aviationEvent;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditEventLocationComponent.prototype.updateTimeZones = function (countryCode, countryChange) {
        if (countryChange === void 0) { countryChange = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var displayTimezone, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(countryCode === 'US')) return [3 /*break*/, 1];
                        this.timezones = USTimezones;
                        if (countryChange) {
                            this.formGroup.patchValue({ timezone: '' });
                        }
                        else {
                            displayTimezone = USTimezones.find(function (i) { return i.countryCode === _this.aviationEvent.timezone; }).zoneName;
                            this.formGroup.patchValue({ timezone: displayTimezone });
                        }
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getTimezones(countryCode)];
                    case 2:
                        _a.timezones = _b.sent();
                        if (countryChange) {
                            if (this.timezones.length === 1) {
                                this.formGroup.patchValue({ timezone: this.timezones[0].zoneName });
                            }
                            else {
                                this.formGroup.patchValue({ timezone: '' });
                            }
                        }
                        else {
                            this.formGroup.patchValue({ timezone: this.aviationEvent.timezone });
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return EditEventLocationComponent;
}());
export { EditEventLocationComponent };
